<template>
  <div class="right-title">
    <div class="right-title__left">
      <div class="title">구독신청</div>
    </div>
  </div>
  <div class="price-wrap">
    <div class="price-item subscribe">
      <div class="price-title">
        <div class="is-14b">정기구독</div>
        <div class="is-12r">오프라인</div>
      </div>
      <div class="price-item__detail">
        <div v-for="regular in price['01']" :key="'reg' + regular.id" class="detail-item">
          <div class="period">{{ regular.name }}</div>
          <div class="price">
            <div v-if="regular.isDiscount" class="origin-price">{{ comma(regular.price) }}<span>원</span></div>
            <triangle-right v-if="regular.isDiscount" />
            <div class="final-price">{{ regular.isDiscount ? comma(regular.discountPrice) : comma(regular.price)
              }}<span>원</span></div>
          </div>
          <div class="apply-btn is-14b" @click="goMagazinePayment(regular.id, 'offline')">구독신청</div>
        </div>
      </div>
    </div>
    <div class="price-item subscribe">
      <div class="price-title">
        <div class="is-14b">온라인 구독</div>
        <div class="is-12r">e-Book</div>
      </div>
      <div class="price-item__detail">
        <div v-for="regular in price['02']" :key="'reg' + regular.id" class="detail-item">
          <div class="period">{{ regular.name }}</div>
          <div class="price">
            <div v-if="regular.isDiscount" class="origin-price">{{ comma(regular.price) }}<span>원</span></div>
            <triangle-right v-if="regular.isDiscount" />
            <div class="final-price">{{ regular.isDiscount ? comma(regular.discountPrice) : comma(regular.price)
              }}<span>원</span></div>
          </div>
          <div class="apply-btn is-14b cursor" @click="goMagazinePayment(regular.id, 'online')">구독신청</div>
        </div>
      </div>
    </div>
    <div class="price-item subscribe">
      <div class="price-title">
        <div class="is-14b">패키지 구독</div>
        <div class="is-12r">정기구독+온라인구독</div>
      </div>
      <div class="price-item__detail">
        <div v-for="regular in price['03']" :key="'reg' + regular.id" class="detail-item">
          <div class="period">{{ regular.name }}</div>
          <div class="price">
            <div v-if="regular.isDiscount" class="origin-price">{{ comma(regular.price) }}<span>원</span></div>
            <triangle-right v-if="regular.isDiscount" />
            <div class="final-price">{{ regular.isDiscount ? comma(regular.discountPrice) : comma(regular.price)
              }}<span>원</span></div>
          </div>
          <div class="apply-btn is-14b" @click="goMagazinePayment(regular.id, 'offline')">구독신청</div>
        </div>
      </div>
    </div>
  </div>
  <div class="is-16r">※ 월간인사관리는 정기(연간)구독제가 원칙입니다. 6개월 이상 구독 시에는 환불조치가 안됩니다.</div>

  <div class="detail-subject">문의</div>
  <h1><span style="font-size: 16px;">월간인사관리 편집팀 </span></h1>
  <p><span style="font-size: 16px;">hrmagazine@insabank.com </span></p>
  <p><span style="font-size: 16px;">TEL 02-2268-2503 </span></p>

</template>

<script>
import {comma} from '~/utils/function.js'
import {useMagazineStore} from '~/store/magazine/index.js'
import {useOrderStore} from '~/store/order/index.js'
import {useMemberStore} from '~/store/member/index.js'
import TriangleRight from 'assets/svg/triangle-right.vue'

export default {
  name: 'MagazineTab4',
  components: {TriangleRight},
  setup() {
    const store = useMagazineStore()
    const orderStore = useOrderStore()
    const memberStore = useMemberStore()
    return {store, orderStore, memberStore}
  },
  props: {
    menu: {
      type: Number,
      default: ''
    }
  },
  data() {
    return {
      isAuth: false,
      comma,
      price: {
        '01': [
          {
            id: 0,
            name: '',
            isDiscount: 0,
            discountType: '',
            price: 0,
            discountPrice: 0,
            discountAmount: 0
          }
        ],
        '02': [
          {
            id: 0,
            name: '',
            isDiscount: 0,
            discountType: '',
            price: 0,
            discountPrice: 0,
            discountAmount: 0
          }
        ],
        '03': [
          {
            id: 0,
            name: '',
            isDiscount: 0,
            discountType: '',
            price: 0,
            discountPrice: 0,
            discountAmount: 0
          }
        ]
      }
    }
  },
  async mounted() {
    this.isAuth = this.memberStore.isAuthenticated
    await this.getMagazinePrice()
  },
  methods: {
    goMagazinePayment(priceId, type) {
      if (!this.isAuth) {
        alert('로그인 후 이용해주세요.')
        return
      }
      this.$router.push(`/magazine/payment?priceId=${priceId}&type=${type}`)
    },
    async postCart(regular) {
      try {
        await this.orderStore.postCart({targetId: regular.id, type: '01'})
        if (confirm('장바구니에 담겼습니다.장바구니로 이동하시겠습니까?')) {
          this.$router.push('/cart')
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getMagazinePrice() {
      try {
        const {data} = await this.store.getMagazinePrice()
        this.price = data
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.right-title {
  border-top: 1px solid #dbdbdb;
  border-bottom: 1px solid #dbdbdb;
  background: #f8fbfd;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  .right-title__left {
    display: flex;
    align-items: center;
    gap: 8px;

    .title {
      color: #0058aa;
      font-family: 'Godo', sans-serif;
      font-size: 18px;
      font-weight: 700;
    }
  }

  .is-14m {
    display: flex;
    padding: 7px 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    border: 1px solid #dbdbdb;
    background: #f2f2f2;
    cursor: pointer;
  }
}

.price-wrap {
  margin-bottom: 24px;
  border: 1px solid #dbdbdb;

  .price-item {
    display: flex;
  }

  .price-title {
    width: 136px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fbfbfb;
    border-right: 1px solid #dbdbdb;
    border-bottom: 1px solid #dbdbdb;
  }

  .price-item__detail {
    .detail-item {
      height: 50px;
      display: flex;
      border-bottom: 1px solid #dbdbdb;
    }

    .period {
      width: 160px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #dbdbdb;
      font-size: 14px;
      font-weight: 400;
    }

    .price {
      width: 277px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #dbdbdb;

      .origin-price {
        font-size: 14px;
        font-weight: 400;
        text-decoration: line-through;
      }

      .final-price {
        font-size: 14px;
        font-weight: 400;
        color: #e40e0e;
      }
    }

    .cart-btn {
      width: 106px;
      background: #f2f2f2;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #dbdbdb;
      cursor: pointer;
    }

    .apply-btn {
      width: 140px;
      background: #0058aa;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}
</style>
